<template>
  <v-tooltip
    :disabled="!title || title.trim().length == 0"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :elevation="elevation"
        class="text-capitalize"
        :class="
          hasTheme ? themes[theme].class + ' ' + classButton : classButton
        "
        @click="clickHandler"
        :color="hasTheme ? themes[theme].color : backgroundColor"
        :x-small="xSmall"
        :small="small"
        :large="large"
        :medium="medium"
        :icon="hasTheme ? themes[theme].icon : isIcon"
        :disabled="disabled || showLoad"
        :block="block"
        :loading="loading"
        :outlined="hasTheme ? themes[theme].outlined : outlined"
        :to="href"
        :style="
          buttonStyle +
          (hasTheme && theme === 'secondaryFilled'
            ? 'background-color: white;'
            : '')
        "
        :tile="hasTheme ? themes[theme].tile : false"
      >
        <v-progress-circular
          class="mr-1"
          v-if="showLoad"
          indeterminate
          color="primary"
          size="20"
        ></v-progress-circular>
        <slot>
          <span :style="`color: ${textColor};`">
            <v-icon
              :small="smallIcon"
              :x-small="xSmallIcon"
              :class="iconClass"
              :style="`color: ${textColor};`"
              v-if="icon"
              >mdi-{{ icon }}</v-icon
            >
            <v-icon
              :small="smallIcon"
              :x-small="xSmallIcon"
              :class="iconClass"
              :style="`color: ${textColor};`"
              v-if="faIcon"
              >fa-{{ faIcon }}</v-icon
            >
            <span
              v-if="label"
              :style="`color: ${textColor};`"
              >{{ label }}</span
            >
          </span>
        </slot>
      </v-btn>
    </template>
    <span>{{ title }}</span>
  </v-tooltip>
</template>

<script>
// import { VBtn } from "vuetify/lib";

export default {
  components: {
    // VBtn
  },

  name: "be-button",

  props: {
    label: {
      type: String,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "be-primary",
    },
    textColor: {
      type: String,
      default: "var(--v-text-on-primary-base)",
    },
    elevation: {
      type: [Number, String],
      default: 0,
    },
    icon: {
      type: String,
    },
    faIcon: {
      type: String,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    classButton: {
      type: String,
    },
    showLoad: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    href: {
      type: Object,
      default: () => {},
    },
    link: {
      type: String,
    },
    buttonStyle: {
      type: String,
      required: false,
      default: "",
    },
    theme: {
      type: String | undefined,
      default: undefined,
    },
    iconClass: {
      type: String,
      required: false,
    },
    xSmallIcon: {
      type: Boolean,
      required: false,
    },
    smallIcon: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      themes: {
        primary: {
          outlined: false,
          tile: false,
          icon: false,
          color: "be-primary",
          class: "font-weight-bold text-capitalize text-on-primary--text",
        },
        secondary: {
          outlined: true,
          tile: false,
          icon: false,
          color: "be-standard-text",
          class: "font-weight-bold text-capitalize be-standard-text--text",
        },
        secondaryFilled: {
          outlined: true,
          tile: false,
          icon: false,
          color: "be-standard-text",
          class: "font-weight-bold text-capitalize",
        },
        secondaryDark: {
          outlined: true,
          tile: false,
          icon: false,
          color: "white",
          class: "font-weight-bold text-capitalize",
        },
        iconRound: {
          outlined: false,
          tile: false,
          icon: true,
          color: "be-primary",
          class: "",
        },
        iconSquare: {
          outlined: false,
          tile: true,
          icon: true,
          color: "be-primary",
          class: "",
        },
        danger: {
          outlined: false,
          tile: false,
          icon: false,
          color: "be-error",
          class: "font-weight-bold text-capitalize white--text",
        },
      },
    };
  },

  computed: {
    hasIcon() {
      if (this.icon) {
        return true;
      }
      return false;
    },
    hasTheme() {
      if (this.theme) {
        return true;
      }
      return false;
    },
  },

  methods: {
    clickHandler() {
      this.$emit("clickHandler");
      this.$emit("click");
    },
  },
};
</script>

<style scoped src="./button.css" lang="css"></style>
